<template>
    <div class="timepicker">
        <ul class="timepicker__hours">
            <li class="hint">часы</li>
            <li v-for="(hr, index) in hours" :key="index" :class="{ active: hour === hr }" @click="select('hour', hr)">
                {{ hr }}
            </li>
        </ul>
        <ul class="timepicker__minutes">
            <li class="hint">минуты</li>
            <li
                v-for="(m, index) in minutes"
                :key="index"
                :class="{ active: minute === m }"
                @click="select('minute', m)"
            >
                {{ m }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'm-timepicker',
    props: {
        value: {
            type: String,
        },

        minuteInterval: {
            type: [Number, String],
            default: 1,
        },

        formatString: {
            type: String,
            default: 'чч.мм',
        },

        maxHours: {
            type: [String, Number],
        },
    },
    data() {
        return {
            hours: [],
            minutes: [],
            hourType: 'чч',
            minuteType: 'мм',
            hour: '',
            minute: '',
        };
    },

    computed: {
        displayTime() {
            let formatString = String(this.formatString);
            if (this.hour) {
                formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
            }
            if (this.minute) {
                formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
            }
            if (this.second && this.secondType) {
                formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
            }
            if (this.apm && this.apmType) {
                formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
            }
            return formatString;
        },
    },

    watch: {
        hour(newValue) {
            this.$emit('change', `${newValue}:${this.minute ? this.minute : 'мм'}`);
        },

        minute(newValue) {
            this.$emit('change', `${this.hour ? this.hour : 'чч'}:${newValue}`);
        },
    },

    mounted() {
        this.renderHoursList();
        this.renderMinutesList();
        if (this.value) {
            const segments = this.value.split(':');
            this.hour = segments[0];
            this.minute = segments[1];
        }
    },

    methods: {
        select(type, value) {
            this[type] = value;
        },

        renderHoursList() {
            const hoursCount = this.maxHours;
            const hours = [];
            for (let i = 0; i < hoursCount; i++) {
                hours.push(i < 10 ? `0${i}` : String(i));
            }
            this.hours = hours;
        },

        renderMinutesList() {
            const minutesCount = 60;
            const minutes = [];
            for (let i = 0; i < minutesCount; i++) {
                minutes.push(i < 10 ? `0${i}` : String(i));
            }
            this.minutes = minutes.filter((x) => x % this.minuteInterval === 0);
        },
    },
};
</script>

<style lang="scss">
.timepicker {
    display: inline-flex;

    &__hours,
    &__minutes {
        width: 90px;
        height: 220px;
        overflow-x: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background-color: #e4e4e4;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #4bace3;
            border-radius: 4px;
        }

        li {
            padding: 8px 0;
            text-align: center;

            &.hint {
                color: #bebebe;
            }

            &.active {
                background-color: #0eccaa;
                color: #fff;
            }

            &:not(.hint):not(.active):hover {
                background-color: #bebebe;
                cursor: pointer;
            }
        }
    }
}
</style>
